import { useState } from 'react';
import { Footer } from '../../components/Footer/Footer';
import { ForgotPasswordForm } from '../../components/ForgotPasswordForm/ForgotPasswordForm';
import { ResetPasswordForm } from '../../components/ResetPasswordForm/ResetPasswordForm';
import { Success } from '../../components/Success/Success';
import { APP_PATHS } from '../../constants/paths';
import { Copy } from '../../copy/Copy';
import { PageContainer } from '../../containers/PageContainer/PageContainer';

export const ResetPassword = () => {
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [userEmail, setUserEmail] = useState();
  const [isResetComplete, setIsResetComplete] = useState(false);

  const handleCodeSent = (email) => {
    setIsCodeSent(true);
    setUserEmail(email);
  };

  const handleReset = () => {
    setIsResetComplete(true);
  };

  return (
    <PageContainer>
      {!isCodeSent && !isResetComplete && (
        <ForgotPasswordForm handleCodeSent={handleCodeSent} />
      )}

      {isCodeSent && !isResetComplete && (
        <ResetPasswordForm userEmail={userEmail} handleReset={handleReset} />
      )}

      {isCodeSent && isResetComplete && (
        <Success
          title={Copy.generate('ResetPassword.title')}
          to={APP_PATHS.login}
          textIdentifier="Links.resetSuccess"
          linkText={Copy.generate('Global.login')}
        />
      )}

      <Footer />
    </PageContainer>
  );
};
